import { buildTree, Node, Tree } from "utils/tree";
import { get, has, isUndefined } from "lodash";

import layoutRoute from "./Layout/route";
import homeRoute from "./Dashboard/Home/route";
import dashboardRoute from "./Dashboard/route";
import dashboardProductsRoute from "./Dashboard/Products/route";
import accountSettingsRoute from "./Dashboard/AccountSettings/route";
import modelRoute from "./Dashboard/Model/route";
import infoRoute from "./Info/route";
import errorRoute from "./Error/route";
import notfoundRoute from "./NotFound/route";

import aboutRoute from "./Info/About/route";
import infoHomeRoute from "./Info/Home/route";
import ourproductsRoute from "./Info/OurProducts/route";
import infoContactRoute from "./Info/Contact/route";
import emailVerifiedRoute from "./Info/EmailVerified/route";
import draftAccessRoute from "./Info/DraftAccess/route";

import teamRoute from "./Info/About/Team/route";
import journalArticlesRoute from "./Info/About/JournalArticles/route";
import conferencePapersRoute from "./Info/About/ConferencePapers/route";
import technicalReportsRoute from "./Info/About/TechnicalReports/route";

import introductionRoute from "./Info/OurProducts/Introduction/route";
import platformRoute from "./Info/OurProducts/Platform/route";

// dev routes
import devRoute from "./Dev/route";
import devInputRoute from "./Dev/Input/route";
import devOutputRoute from "./Dev/Output/route";
import devMarkdownRoute from "./Dev/Markdown/route";
import devConfigGuideRoute from "./Dev/ConfigGuide/route";
import devMarkdownGuideRoute from "./Dev/MarkdownGuide/route";

import { IUser } from "controllers/users/action";
import { RouteType } from "./types";
export { default as Layout } from "./Layout/index";
export { default as About } from "./Info/About/index";
export { default as Error } from "./Error/index";
export { default as Home } from "./Info/Home/index";
export { default as NotFound } from "./NotFound/index";

export interface RouteProps {
  node: Node<RouteType>;
  page: RouteType;
  routes: Tree<RouteType>;
}

export interface RootProps extends RouteProps {
  notice?: any;
  user?: IUser;
  currentRoute?: RouteType;
  previousRoute?: RouteType;
  setCurrentRoute?: (route: RouteType) => void;
  setPreviousRoute?: (route: RouteType) => void;
}

/**
 * Node tree of all of the routes for this app.
 */
export const routes = buildTree(
  [
    layoutRoute,
    homeRoute,
    dashboardRoute,
    dashboardProductsRoute,
    accountSettingsRoute,
    modelRoute,
    infoRoute,
    aboutRoute,
    errorRoute,
    notfoundRoute,
    infoHomeRoute,
    ourproductsRoute,
    infoContactRoute,
    emailVerifiedRoute,
    draftAccessRoute,
    teamRoute,
    journalArticlesRoute,
    conferencePapersRoute,
    technicalReportsRoute,
    introductionRoute,
    platformRoute,
    devRoute,
    devInputRoute,
    devOutputRoute,
    devMarkdownRoute,
    devConfigGuideRoute,
    devMarkdownGuideRoute,
  ].sort((a, b) => a.id - b.id)
);

/**
 * Builds a relative link path given a route node.
 * @param node the route node
 * @returns the relative path
 * Check if path is undefined
 */
export const constructPath = (node: Node<RouteType> | undefined): string => {
  return node && has(node, ["parent", "data", "path"]) && !isUndefined(node?.data?.path)
    ? `${constructPath(node.parent)}${node.data ? `/${node.data.path}` : ""}`.replace("//", "/")
    : !isUndefined(node?.data?.path)
    ? `${get(node, ["data", "path"], "")}`
    : "";
};

/**
 * Find a route node given an id, name, or label.
 * @param query the id, name, or label
 * @returns the route node if found
 */
export const findRoute = (root: Tree<RouteType>, query: string | number): Node<RouteType> | undefined =>
  root.findNode(query) || Object.values(root.map).find((r) => [r.data?.name, r.data?.label].includes(query));
